import { useSelector } from '@xstate/store/react';
import { useCanvasStores } from '../stores/CanvasContext';
import type { ConnectorSide } from '../types';

export function useMergedDropTarget() {
  const { dragStore } = useCanvasStores();
  const connectionDropTarget = useSelector(dragStore, s => s.context.connectionDropTarget);
  const redockDropTarget = useSelector(dragStore, s => s.context.redockDropTarget);
  const mergedDropTarget = connectionDropTarget ?? redockDropTarget;
  const mergedDropTargetId = mergedDropTarget?.entityId ?? null;
  const mergedDropTargetSide = (mergedDropTarget && mergedDropTarget.side !== 'center') ? mergedDropTarget.side as ConnectorSide : null;
  return { mergedDropTargetId, mergedDropTargetSide };
}
